/**
 * Frontend mirror of the backend's synthetic `report_to_user` staged action
 * identifiers (http-gateway `lib/schemas/tools.ts`). A report card is a
 * delivered message, not a proposed write — "invoking" it only marks it read,
 * so renderers drop the invoke CTA (copy, and being done with it, are the only
 * actions) and badge the card with the icon of the skill that produced it when
 * one is attributed.
 */
export const REPORT_TO_USER_STAGED_TOOLSET = 'report_to_user'
export const REPORT_TO_USER_STAGED_TOOLNAME = 'message'

export function isReportToUserStagedAction(action: { toolSet?: string; toolName?: string }): boolean {
  return action.toolSet === REPORT_TO_USER_STAGED_TOOLSET && action.toolName === REPORT_TO_USER_STAGED_TOOLNAME
}

/**
 * The skill name to badge a report card with — set only for `report_to_user`
 * actions whose run was spawned with a skill attribution.
 */
export function getReportOriginSkill(action: {
  toolSet?: string
  toolName?: string
  sourceMetadata?: { originSkill?: string }
}): string | undefined {
  return isReportToUserStagedAction(action) ? action.sourceMetadata?.originSkill : undefined
}
